<template>
	<!-- <Select :size="'m'" :list="[]" v-model="" :bindActive="" :qtyType="'multiple'" :displayFilter="d=>()" :search="{key:'',placeholder:getLanguageStr('','')}" :dir="'up/down'" @Click="$set(,'',timeLimit[arguments[0]].value)" :bindActive=""></Select> -->
	<div class="select tra-fast_E" :class="[sizeClass, styleType]">
		<div class="selectDisplay fSub bgSelect" :class="{ error: option.error, bdSub: border }">
			<span v-if="list.length > 0" class="active" :title="display">{{ display }}</span>
			<span v-else>--</span>
			<div class="ico">
				<Icon :name="'arrow-' + getDir" class="w105x h2x fSub" />
			</div>
			<!-- <span class="ico fa cLight tra-fast" :class="'fa-angle-'+dir"></span> -->
		</div>
		<div v-if="ready" class="dropList bgContent cMainContent" :class="[option.dir === 'down' ? '' : 'dropList-dropUp']">
			<div v-if="search" class="bdSub-bottom">
				<InputText
					v-model="searchValue"
					:styleType="'noBorder'"
					:addClass="'pl1x'"
					:clearBtn="true"
					:placeholder="search.placeholder"
					@Keyup="searchDo"
				></InputText>
			</div>
			<div v-if="dropShow" :class="{ 'h30x-max': !search, 'h24x-max': search }" scroll>
				<div v-if="bindMode === 'target'" class="tra-fast_E hover-bg-highLight_E">
					<!-- 原始列表选项 li[keyMap.text]&&-->
					<a
						v-if="!searchValue && li.token != true"
						v-for="(li, i) in list"
						:key="i"
						@click="select(i)"
						:class="[
							{
								active: (bindActive != '' ? bindActive == li[keyMap.value] : myIndex === i) || li.select,
								disable: li.disable,
							},
							li.class,
						]"
						:title="li[keyMap.text]"
					>
						{{ li[keyMap.text] }}
					</a>
					<!-- 搜索结果 -->
					<a
						v-if="searchValue && li.token != true"
						v-for="(li, i) in option.data"
						:key="i"
						@click="selectSearch(i)"
						:class="[
							{
								active: qtyType == 'single' && hightLight && list[myIndex][keyMap.value] == li[keyMap.value],
								disable: !li[keyMap.value],
								disable: li.disable,
							},
							li.class,
						]"
						:title="li[keyMap.text]"
					>
						{{ li[keyMap.text] }}
					</a>
				</div>
				<div v-else-if="bindMode === 'dispersion'" class="tra-fast_E hover-bg-highLight_E">
					<a
						v-if="!searchValue && li.token != true"
						v-for="(li, i) in list"
						:key="i"
						@click="select(i)"
						:class="{
							active: bindActive != '' ? bindActive[li[keyMap.value]] : myIndex === i,
							disable: li.disable,
						}"
						>{{ li[keyMap.text] }}
					</a>
				</div>
			</div>
			<slot name="static"></slot>
		</div>
		<div v-if="option.errorTip" class="errorTip tra-fast">
			{{ option.errorTip }}
		</div>
	</div>
</template>
<script>
import { setNewScroll, objTool } from "@/util/lib.js";
import { getLanguageStr } from "@/util/language.js";

let defListData = {
	text: getLanguageStr("phrase151", "暂无搜索结果"),
	value: undefined,
	def: "",
	class: "disable",
};

export default {
	components: {},
	props: {
		value: {
			type: [String, Number],
			default: undefined,
		},
		name: {
			// 激活的索引项
			type: String,
			default: "",
		},
		qtyType: {
			// 单选、多选，需要配合列表数据中clearOther、select属性
			type: String,
			default: "single", // multiple
		},
		addClass: {
			// 激活的索引项
			type: [String, Object],
			default: "",
		},
		size: {
			//展示尺寸
			type: String,
			default: "m",
		},
		list: {
			type: Array,
			default: () => [{ text: "", value: -1, def: "" }], // [{text:"String",value:Int,def:"String:仅第一个元素有此属性，用于呈现默认值文本，默认文本在下拉中以下划线与其余选项区分"},....]
		},
		keyMap: {
			// 匹配呈现的字段
			type: Object,
			default: function () {
				return {
					text: "text",
					value: "value",
				};
			},
		},
		activeIndex: {
			// 激活的索引项
			type: Number,
			default: 0,
		},
		dir: {
			// 激活的索引项
			type: String,
			default: "down",
		},
		bindActive: {
			// 绑定的激活项
			// type:[String,Number,Object],
			default: "",
		},
		bindMode: {
			// 判断激活的模式
			type: String,
			default: "target", // "target"：激活项的判断针对某一个变量;"dispersion"：激活判断按照每一条数据自身的值(适用于多选)
		},
		isError: {
			type: Boolean,
			default: false,
		},
		errorTip: {
			type: String,
			default: "",
		},
		verification: {
			// 验证方式
			type: String,
			default: "",
		},
		styleType: {
			// 专有样式:plantName,phonePrefix
			type: String,
			default: "",
		},
		hightLight: {
			// 高亮显示激活项
			type: Boolean,
			default: true,
		},
		search: {
			// 搜索过滤条件
			type: Object,
			default: null, // {key:String}
		},
		displayFilter: {
			// 显示条件过滤
			type: Function,
			default: null,
		},
		border: {
			//是否显示边框
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			hover: false,
			dropShow: true,
			ready: false,
			option: {
				error: this.isError,
				errorTip: this.errorTip,

				dir: this.dir,

				data: this.list,
			},
			searchValue: "",
			myIndex: this.activeIndex,
			error: false,
		};
	},
	watch: {
		value: function () {
			this.findActive();
		},
		bindActive: {
			deep: true,
			handler: function () {
				// 监视并显示对应指定的激活值
				this.findActive();
			},
		},
		list: {
			deep: true,
			handler: function (n, o) {
				// 监视并显示对应指定的激活值
				if (this.search) this.searchDo();
				if (n.length) {
					if (
						n.length != o.length ||
						n[this.myIndex][this.keyMap.text] != o[this.myIndex][this.keyMap.text] ||
						n[this.myIndex][this.keyMap.value] != o[this.myIndex][this.keyMap.value]
					) {
						// 仅彻底变化数据才进行操作
						let find = false;
						$.each(n, (index, val) => {
							// 再次匹配值是否存在列表里
							if (val[this.keyMap.value] == this.value) {
								// 存在的话表示无需emit新的默认值
								find = true;
								return false;
							}
						});
						if (find == false) this.$emit("input", this.list.length ? this.list[0][this.keyMap.value] : undefined); // 切换数据后自动使用第一条数据的值
						$(this.$el).find("[scroll]").mCustomScrollbar("update");
					}
				} else {
					this.$emit("input", undefined);
				}
				this.findActive();
			},
		},
		dropShow: function (val) {
			//防止刷数据的时候导致下拉内容消失
			if (this.hover && val == false) {
				this.dropShow = true;
			}
		},
	},
	created() {
		if (this.activeIndex < 0) trace("传入的activeIndex为：" + this.activeIndex); // 传值错误提醒
		if (this.bindActive) {
			this.findActive();
		}
	},
	methods: {
		reset: function (clearAll = false) {
			if (clearAll === true) {
				this.select(0);
			}
			this.option.error = this.isError;
			this.option.errorTip = this.errorTip;
		},
		select: function (targetIndex) {
			let selectIndex = targetIndex;
			let outValue = this.list[targetIndex][this.keyMap.value] !== undefined ? this.list[targetIndex][this.keyMap.value] : this.list[targetIndex].id;
			switch (this.qtyType) {
				case "single":
					$(this.$el).find(".dropList").css("pointer-events", "none"); // 点击后隐藏下拉
					setTimeout(() => {
						$(this.$el).find(".dropList").css("pointer-events", "");
					}, 500);
					break;
				case "multiple":
					selectIndex = [];
					outValue = [];
					let $this = this;

					let defItemIndex;
					$.each(this.list, function (index) {
						// 记录默认选中值
						if (this.clearOther == true) {
							defItemIndex = index;
						}
					});

					if (this.list[targetIndex].clearOther) {
						// 点击默认值
						$.each(this.list, function () {
							if (this.select == true) {
								this.select = false;
							}
						});
						this.list[targetIndex].select = true;
					} else {
						// 点击其它的，就吧全部类的选项去除选择
						if (this.list[targetIndex].select == true) {
							this.list[targetIndex].select = false; // 重复点击取消选择该项
						} else this.list[targetIndex].select = true;
						this.list[defItemIndex].select = false;
					}
					$.each(this.list, function (index) {
						if (this.select) {
							selectIndex.push(index);
							outValue.push(this[$this.keyMap.value]);
						}
					});

					if (selectIndex.length == 0) {
						// 什么都不选纠正到选择默认
						this.list[defItemIndex].select = true;
						selectIndex = [defItemIndex];
					}
					break;
			}
			if (this.list[targetIndex].statistic)
				statistic(
					this.list[targetIndex].statistic.a,
					this.list[targetIndex].statistic.b,
					this.list[targetIndex].statistic.c,
					this.list[targetIndex].statistic.d
				);
			this.$emit("input", outValue);
			this.$set(this, "myIndex", selectIndex);
			this.$emit("Click", targetIndex, this.name);
		},
		selectSearch: function (targetIndex, e) {
			let index = objTool(this.list, "findByKey", [this.keyMap.value, this.option.data[targetIndex][this.keyMap.value]])[0];
			this.select(index, e);
		},
		findActive: function () {
			let findIndex = this.bindActive === undefined ? 0 : -1;
			switch (this.qtyType) {
				case "single":
					let $this = this;
					if (this.bindActive !== undefined) {
						switch (this.bindMode) {
							case "target":
								this.list.forEach((item, index) => {
									if ((this.bindActive || this.value) === item[$this.keyMap.value]) {
										this.$set(this, "myIndex", index);
										findIndex = index;
									}
								});
								break;
							case "dispersion":
								let targetKey = "";
								$.each(this.bindActive, function (key) {
									if (this) {
										$this.$set($this.bindActive, key, true);
										targetKey = key;
									}
								});
								if (targetKey == "") {
									// 没有激活项，找出默认项
									$.each(this.list, function (index) {
										if (this.def != undefined) {
											$this.$set($this, "myIndex", index);
											findIndex = index;
										}
									});
									targetKey = this.list[this.myIndex][this.keyMap.value];
									$.each(this.list, function (index) {
										// 查找并激活目标选项
										if (this[$this.keyMap.value] == targetKey) {
											$this.$set($this.bindActive, targetKey, true);
										}
									});
								} else {
									// 已知key就找出对应的index
									$.each(this.list, function (index) {
										if (this[$this.keyMap.value] == targetKey) {
											$this.$set($this, "myIndex", index);
											findIndex = index;
										}
									});
								}
								break;
						}
					}
					break;
				case "multiple":
					findIndex = [];
					$.each(this.list, function (index) {
						if (this.select) findIndex.push(index);
					});
					this.myIndex = [...findIndex];
					break;
			}
			return findIndex;
		},
		searchDo: function () {
			// 匹配搜索结果和更新列表
			if (this.searchValue) {
				this.option.data = [];
				let $this = this;
				$.each(this.list, function () {
					if (this[$this.search.key].toLowerCase().replace(/\s/g, " ").includes($this.searchValue.toLowerCase())) {
						if ($this.option.data.length == 0) $this.option.data.push({ token: true }); //补充一个空内容，方便判断已匹配的
						$this.option.data.push(this);
					}
				});
			} else {
				this.option.data = this.list;
			}
			if (this.option.data.length == 0) {
				let def = { class: defListData.class },
					list = [{ token: true }];
				def[this.keyMap.text] = defListData.text;
				def[this.keyMap.value] = defListData.value;
				list.push(def);
				this.option.data = list;
			}
			this.$nextTick(() => {
				// 下拉面板宽度最小为上层展示的宽度
				let $dropList = $(this.$el).find(".dropList");
				if ($dropList.innerWidth() < $(this.$el).innerWidth()) {
					$dropList.css("min-width", $(this.$el).innerWidth());
				} else {
					$dropList.css("min-width", "");
				}
			});
		},
		doVerification: function () {
			let out = true;
			let val = this.list[this.myIndex][this.keyMap.value];
			switch (this.verification) {
				case "notEmpty":
					out = !!(val || Number(val) > 0);
					break;
			}
			if (out == false) {
				this.option.error = true;
				this.option.errorTip = getLanguageStr("phrase3", "不能为空");
			}
			return out;
		},
		fixDropPos: function () {
			if (
				($(this.$el).parents(".window-alert").length > 0 ||
					$(this.$el).parents(".window-new").length > 0 ||
					$(this.$el).parents(".mCustomScrollBox").length > 0) &&
				!$(this.$el).addClass("fixedMode")
			) {
				$(this.$el).addClass("fixedMode");
			}
			if ($(this.$el).hasClass("fixedMode")) {
				$(this.$el).find(".dropList").css("min-width", $(this.$el).width()); //自动设置下拉最小宽度和父级一致
			}
			let $dropList = $(this.$el).find(".dropList");
			// 上下修正
			if (!this.dir || this.dir == "down" || $(this.$el).hasClass("fixedMode")) {
				// 默认的场景或fixed模式才自动修正
				let dropH = $dropList.innerHeight() + stage.space;
				let t = $(this.$el).offset().top + $(this.$el).innerHeight();
				if (t + dropH + stage.space > $(window).height()) {
					this.option.dir = "up";
					if ($(this.$el).hasClass("fixedMode")) {
						$dropList.css("margin-top", -dropH - $(this.$el).innerHeight());
					}
				} else {
					this.option.dir = "down";
					if ($(this.$el).hasClass("fixedMode")) {
						$dropList.css("margin-top", "");
					}
				}
			}
			// 左右修正
			let dropW = $dropList.innerWidth();
			let l = $(this.$el).offset().left;
			if (l + dropW > $(window).width()) {
				$dropList.addClass("dropList-right");
			} else {
				$dropList.removeClass("dropList-right");
			}
		},
	},
	computed: {
		sizeClass: function () {
			switch (this.size) {
				case "m":
					return "sizeM";
					break;
				case "l":
					return "sizeL";
					break;
				case "s":
				default:
					return "sizeS";
					break;
			}
		},
		display: function () {
			// 显示激活文本
			let out = "";
			let $this = this;
			if (this.displayFilter) {
				out = this.displayFilter(this.list[this.myIndex]);
			} else {
				switch (this.qtyType) {
					case "single":
						if (this.list[this.myIndex].def) {
							out = this.list[this.myIndex].def;
						} else {
							out = this.list[this.myIndex][this.keyMap.text];
						}
						break;
					case "multiple":
						$.each(this.myIndex, function () {
							if (out != "") out += ",";
							out += $this.list[this][$this.keyMap.text];
						});
						break;
				}
			}
			return "array,string".includes($.type(out)) && out.includes("undefined") ? "--" : out;
		},
		getDir: function () {
			let dir = "";
			switch (this.option.dir) {
				case "down":
					dir = "d";
					break;
				case "up":
					dir = "u";
					break;
			}
			return dir;
		},
	},
	mounted() {
		this.findActive();

		setTimeout(() => {
			//延时处理下拉，提高初始运行速度
			this.ready = true;
			this.$nextTick(() => {
				this.fixDropPos();
				let $this = this;
				$(this.$el).on("mouseenter", (e) => {
					// 移入检测定位
					this.hover = this.dropShow = true;
					this.$nextTick(() => {
						setNewScroll($(this.$el).find("[scroll]"));
						$this.fixDropPos();
					});
				});
				$(this.$el).on("mouseleave", (e) => {
					this.hover = false;
					setTimeout(() => {
						if (this.hover == false) {
							this.dropShow = false;
						}
					}, 200);
				});
				setTimeout(() => {
					this.dropShow = false;
				}, 0);
			});
		}, Math.random() * 20);
	},
	destroyed: function () {
		this.$emit("Destroyed", "");
	},
};
</script>
<style lang="scss" scoped>
a:not(.active):hover {
	color: inherit;
}
.select {
	position: relative;
	display: inline-block;
	line-height: 1;
	text-align: left;
	&.dpB {
		display: block;
	}
	&.fixedMode {
		.dropList {
			position: fixed;
			top: unset;
			bottom: unset;
			left: unset;
			min-width: unset;
		}
	}
	// >*{height:2em;}
	.selectDisplay,
	.box {
		position: relative;
		display: table;
		width: inherit;
		height: 100%;
		padding: 0 1.5rem;
		cursor: pointer;
		table-layout: fixed;
		border-collapse: separate; //table-layout:fixed;
		border-radius: $radiusLight;
		> * {
			display: table-cell;
			vertical-align: middle;
		}
		> .ico {
			width: 3rem;
			padding: {
				left: 1rem;
			}
		}
		.active {
			max-width: 30em;
			@extend %textCut;
		}
	}

	[class*="fa-angle-"] {
		line-height: inherit;
		&:before {
			font-size: 1.4em;
		}
	}

	&:not(.select-buttonMode) {
		&:hover {
			> .selectDisplay,
			> .box {
				color: $mainColor;
				border-color: $mainColor;
				.ico {
					color: $mainColor;
					* {
						fill: $mainColor;
					}
				}
			}
			> .dropList,
			> [scroll] {
				padding: {
					top: 0.5rem;
					bottom: 0.5rem;
				}
				z-index: 6;
				pointer-events: auto;
				visibility: visible;
				opacity: 1;
			}
		}
	}
	&[active] > :first-child,
	&.active > :first-child {
		border-color: $mainColor;
	}

	&.select-area {
		position: static;
		.dropList {
			top: 2.6em;
			width: 100%;
			white-space: normal;
			padding: {
				right: 0.5em;
				left: 0.5em;
			}
		}
		button,
		a {
			display: inline-block !important;
			min-width: auto !important;
			overflow: visible;
			border-radius: $radiusLight;
		}
	}

	&.select-delay {
		> .dropList {
			pointer-events: auto;
			transition-delay: 1s;
		}
		&:hover > .dropList {
			transition-delay: 0s;
		}
	}

	&.select-m {
		> .box {
			line-height: ($sizeM - 0.1);
		}
		> * {
			height: $sizeM;
		}
	}
	&.select-l {
		> .box {
			line-height: 2.8em;
		}
		> * {
			height: 3em;
		}
		.selectDisplay,
		.box {
			padding: 0 1em;
		}
		[class*="fa-angle-"] {
			padding: {
				left: 1em;
			}
		}
	}
	.dropList {
		transition-property: padding, opacity, visibility;
	}
}
.select + .select {
	margin: {
		left: 2rem;
	}
}
.plantName {
	//电站详情展示的样式
	.selectDisplay {
		padding: {
			left: 0;
		}
		font-size: $fsLv4;
		border: none;
		.active {
			max-width: 10em;
		}
	}
}
.noBorder {
	.selectDisplay {
		padding: {
			left: 0;
		}
		border: none;
	}
}
.phonePrefix {
	position: absolute;
	top: 50%;
	left: 0; //手机号前缀选择
	width: 12rem;
	margin: {
		top: -2rem;
	}
	.selectDisplay {
		padding: {
			left: 2rem !important;
		}
		border: none;
	}
}
.showAll {
	.selectDisplay .active {
		max-width: unset;
	}
}
.w30pct .selectDisplay {
	width: 100%;
}

.select {
	.selectDisplay .active {
		color: rgba(0, 0, 0, 0.65);
	}
}
.dropList a {
	&:hover {
		background: #f4f9ff;
	}
	&.active {
		color: #fff;
		background: $primary;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Select.vue